<template>
  <div class="broken-chart-container">
    <!--  标题  -->
    <div class="title-content">
      <p class="title">{{ title }}</p>
      <p v-if="score">
        <!-- <span class="score">{{ score }} </span><span class="util">分</span> -->
      </p>
    </div>
    <!--    折线图    -->
    <div ref="lineChart" class="line-chart-content"></div>
  </div>
</template>

<script>
import { Line } from "@antv/g2plot";

export default {
  name: "brokenLineChart",
  props: {
    // 是否显示标题
    showTitle: {
      type: Boolean,
      default: true,
    },
    // 标题
    title: String,
    // 分数
    score: Number,
    /**
     * 数据
     * @type {
     *     Array<{ name:string; value: number }>
     * }
     */
    resultList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    resultList: function (newVal, oldVal) {
      if (this.area) {
        this.area.destroy();
      }
      this.initChart();
    },
  },
  data() {
    return {
      area: null,
    };
  },
  mounted() {},
  methods: {
    /**
     * 初始化折线图
     */
    initChart() {
      this.area = new Line(this.$refs.lineChart, {
        data: this.resultList,
        appendPadding: [10, 0, 20, 0],
        color: ["#DA7458", "#e7cb88", "#dfb28e"],
        xField: "data",
        yField: "value",
        seriesField: "type",
        area: {},
        lineStyle:{
          lineDash:[4,8],
          lineOpacity:0.5
        },
        point: {
          size: 3,
        },
        xAxis: {
          tickLine: {
            alignTick: true,
          },
          label:{autoHide:false}
        },
        yAxis: {
          max: 10,
          min: 0,
          tickInterval: 2,
        },
        legend: {
          position: "bottom",
          offsetY: -10,
          icon: "circle",
          marker: {
            symbol: "hyphen",
          },
          textStyle: {
            fontSize: 8,
          },
          flipPage:false,
        },
      });
      this.area.render();
    },
  },
};
</script>

<style scoped lang="scss">
.broken-chart-container {
  padding-bottom: 4px;
  .title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $bigSize;
    color: $deepGreen;
    margin-bottom: 14px;

    .title {
      color: $commonTitle;
      font-weight: 500;
    }

    .score {
      line-height: 84px;
      font-size: 52px;
      padding: 0 10px;
      font-weight: 500;
    }

    p:nth-child(2) {
      display: flex;
      align-items: center;
    }
  }

  .line-chart-content {
    width: 652px;
    height: 584px;
    display: flex;
    align-items: center;
    justify-content: center;

    canvas {
      width: 652px !important;
      height: 584px !important;
    }
  }
}
</style>
